import axios from "axios";

// URL dynamique selon le domaine — permet d'utiliser un seul build pour CI et GN
const BACKEND_URL = window.location.origin + "/lmp-api";
export const API = `${BACKEND_URL}/api`;
export const TOKEN_KEY = "lmp_token";

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Une erreur est survenue. Réessayez.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

/** Formate un montant — utiliser useFormatCurrency() dans les composants React pour la devise dynamique. */
export const fcfa = (n, currency = "FCFA") =>
  new Intl.NumberFormat("fr-FR").format(Math.round(n || 0)) + " " + currency;

export default api;
